import { BreadcrumbItem } from "../components/common/Breadcrumb";

export interface BreadcrumbContext {
    hubId?: string | null;
    hubName?: string;
    folderId?: string | null;
    folderName?: string;
    categoryId?: string | null;
    categoryName?: string;
    t: any; // Translation function
}

// Helper for contextual label formatting
const withLabelContext = (typeKey: string, name: string | undefined | null, t: any): string => {
    return `${t(typeKey)}: ${name || t("unnamed")}`;
};

export const generateHubBreadcrumbs = ({ t }: BreadcrumbContext): BreadcrumbItem[] => [
    {
        label: t("myHubs"),
        isActive: true,
    },
];

export const generateHubFoldersBreadcrumbs = ({ hubId, hubName, t }: BreadcrumbContext): BreadcrumbItem[] => [
    {
        label: t("myHubs"),
        path: "/hubs",
    },
    {
        label: withLabelContext("hub", hubName, t),
        isActive: true,
    },
];

export const generateHubFolderCategoriesBreadcrumbs = ({
    hubId,
    hubName,
    folderId,
    folderName,
    t,
}: BreadcrumbContext): BreadcrumbItem[] => [
    {
        label: t("myHubs"),
        path: "/hubs",
    },
    {
        label: withLabelContext("hub", hubName, t),
        path: `/hubs/folders?hubId=${hubId}`,
    },
    {
        label: withLabelContext("folder", folderName, t),
        isActive: true,
    },
];

export const generateSingleTrackCreationBreadcrumbs = ({
    hubId,
    hubName,
    folderId,
    folderName,
    categoryId,
    categoryName,
    t,
}: BreadcrumbContext): BreadcrumbItem[] => [
    {
        label: t("myHubs"),
        path: "/hubs",
    },
    {
        label: withLabelContext("hub", hubName, t),
        path: `/hubs/folders?hubId=${hubId}`,
    },
    {
        label: withLabelContext("folder", folderName, t),
        path: `/hubs/folders/categories?folderId=${folderId}&hubId=${hubId}`,
    },
    {
        label: withLabelContext("category", categoryName, t),
        isActive: true,
    },
];

export const generateHubCreateBreadcrumbs = ({ t }: BreadcrumbContext): BreadcrumbItem[] => [
    {
        label: t("myHubs"),
        path: "/hubs",
    },
    {
        label: t("createHub"),
        isActive: true,
    },
];

export const generateTrackCreationFormBreadcrumbs = ({
    hubId,
    hubName,
    folderId,
    folderName,
    categoryId,
    categoryName,
    t,
}: BreadcrumbContext): BreadcrumbItem[] => [
    {
        label: t("myHubs"),
        path: "/hubs",
    },
    {
        label: withLabelContext("hub", hubName, t),
        path: `/hubs/folders?hubId=${hubId}`,
    },
    {
        label: withLabelContext("folder", folderName, t),
        path: `/hubs/folders/categories?folderId=${folderId}&hubId=${hubId}`,
    },
    {
        label: withLabelContext("category", categoryName, t),
        path: `/hubs/folders/categories/tracks?hubId=${hubId}&folderId=${folderId}&categoryId=${categoryId}`,
    },
    {
        label: t("trackCreation"),
        isActive: true,
    },
];
